import * as React from 'react';

import { compose } from 'recompose';

import connectToStores from 'js/lib/connectToStores';
import Retracked from 'js/lib/retracked';
import useRouter from 'js/lib/useRouter';

import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import CsrfTokenContext from 'bundles/page/contexts/CsrfTokenContext';
import RouterContext from 'bundles/page/contexts/RouterContext';
import ApplicationStoreClass from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/partners-graphql/styl/all';

type PropsFromStores = {
  csrfToken?: string | null;
};

type PropsFromCaller = {
  children: React.ReactNode;
};

type PropsToComponent = PropsFromStores & PropsFromCaller;

const PartnerApp = ({ children, csrfToken }: PropsToComponent) => {
  const router = useRouter();

  return (
    <RouterContext.Provider value={router}>
      <CsrfTokenContext.Provider value={csrfToken || '<MISSING>'}>
        <div className="rc-PartnerApp">
          <PageHeader />
          {children}
          <PageFooter />
        </div>
      </CsrfTokenContext.Provider>
    </RouterContext.Provider>
  );
};

export default compose<PropsToComponent, PropsFromStores>(
  Retracked.createTrackedContainer(() => {
    return {
      namespace: {
        app: 'partners',
      },
    };
  }),
  connectToStores<PropsFromStores, PropsFromCaller, ApplicationStoreClass>(
    [ApplicationStoreClass],
    (ApplicationStore, props) => ({
      ...props,
      csrfToken: ApplicationStore.getState().csrfToken,
    })
  )
)(PartnerApp);
